import { Validators } from "@angular/forms"
import { IFormKey } from "src/app/modules/shared/models/forms"
import { IObjectKey } from "src/app/modules/shared/models/objects"
import { IAddress } from "../address-change/address-change.constants"

export const subject_form_template = {
    ndg: null
}

export const subject_form_validators = {
    ndg: [Validators.required]
}

export const subject_form_keys: IFormKey[] = [
    {
        id: 'ndg-field',
        label: 'NDG Nuovo Contraente',
        controlName: 'ndg',
        css: 'col-4',
        type: 'INPUT'
    }
]

export const contractor_variation_form_template = {
    iban: null,
    shareCapital: null,
    addressType: null,
    email: null
}

export const contractor_variation_form_validators = {
    iban: [Validators.required],
    shareCapital: [Validators.required, Validators.pattern(/^\d+(\.\d+)?$/)],
    addressType: [Validators.required],
    email: null
}

export const contractor_variation_form_keys: IFormKey[] = [
    {
        id: 'iban-field',
        label: 'Coordinate bancarie',
        controlName: 'iban',
        css: 'col-4',
        type: 'SELECT',
        options: []
    },
    {
        id: 'shareCapital-field',
        label: 'Capitale sociale',
        controlName: 'shareCapital',
        css: 'col-4',
        type: 'INPUT'
    },
    {
        id: 'new-line-field',
        label: null,
        controlName: null,
        type: 'NEW_LINE',
        css: 'col-12'
    },
    {
        id: 'addressType-field',
        label: 'Selezionare il tipo di recapito:',
        controlName: 'addressType',
        css: 'col-4',
        type: 'RADIO',
        options: [
            { key: 'address', value: 'Postale' },
            { key: 'email', value: 'Email' }
        ]
    },
    {
        id: 'email-new-line-field',
        label: null,
        controlName: null,
        type: 'NEW_LINE',
        css: 'col-12'
    },
    {
        id: 'email-field',
        label: 'Email',
        controlName: 'email',
        css: 'col-4',
        type: 'INPUT',
        hidden: true
    }
]

export const contractor_keys_PF: IObjectKey[] = [
    {
        label: 'NDG',
        key: 'ns2:ndg'
    },
    {
        label: 'Codice fiscale',
        key: 'ns2:codiceFiscale'
    },
    {
        label: 'Data di nascita',
        key: 'ns2:dataNascita',
        pipe: {
            key: 'date',
            value: null
        }
    },
    {
        label: 'Tipologia',
        key: 'ns2:naturaGiuridica'
    }
];

export const contractor_keys_PG: IObjectKey[] = [
    {
        label: 'NDG',
        key: 'ns2:ndg'
    },
    {
        label: 'Partita Iva',
        key: 'ns2:partitaIva'
    },
    {
        label: 'Tipologia',
        key: 'ns2:naturaGiuridica'
    }
];

export interface IBodyVariazioneContraenza {
    policyNumber: string;
    subject: ISubjectPersonaFisica | ISubjectPersonaGiuridica;
    policyHolderFiscalCode: string;
    policyHolderIban: string;
    address: IAddress;
    policyHolderEmail: string;
}

export interface ISubjectPersonaFisica {
    citizenship: string;
    fiscalCode: string;
    isLegalSubject: string;
    name: string;
    occupation: string;
    sex: string;
    surname: string;
    birthDate: string;
    birthAddress: IBirthAddress;
    residence: IResidence;
    privacy?: any;

    docType?: string;
    docNumber?: string;
    docReleaseDate?: string;
    docExpiryDate?: string;
    docPlace?: string;
    docAuthority?: string;
}

export interface IBirthAddress {
    country: string;
    place: string;
    province: string;
}

export interface IResidence {
    country: string;
    place: string;
    province: string;
    postalCode: string;
    toponym?: string;
    address: string;
    addressNumber: string;
}

export interface ISubjectPersonaGiuridica {
    residence: IResidence;
    birthDate: string;
    companyName: string;
    isLegalSubject: string;
    vatNumber: string;
    shareCapital: string;
    privacy?: any;
}

export const CODICE_NAZIONE_ITALIA = "086";
export const SIGLA_CITTA_STATO_ESTERO = "STATO ESTERO";
export const SIGLA_PROVINCIA_STATO_ESTERO = "EE";
export const SIGLA_CAP_STATO_ESTERO = "00000";
